"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var n=function(e){return e==null};exports.isNullOrUndefined=n;
